import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'searching-for-a-travel-expert',
  templateUrl: './searching-for-a-travel-expert.component.html',
  styleUrls: ['./searching-for-a-travel-expert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchingForATravelExpertComponent {}
